import React, { useEffect } from 'react';
import { useLanguage } from '../../contexts/LanguageContext';

const SHORTCUTS = [
  { key: 'search', keys: ['⌘', 'K'], label: 'Abrir buscador rápido' },
  { key: 'help', keys: ['?'], label: 'Mostrar esta ayuda' },
  { key: 'navigate', keys: ['↑', '↓'], label: 'Navegar resultados del buscador' },
  { key: 'select', keys: ['↵'], label: 'Ir a la sección seleccionada' },
  { key: 'close_dialogs', keys: ['Esc'], label: 'Cerrar diálogos y modales' },
];

const Kbd = ({ children }) => (
  <kbd
    style={{
      fontSize: 11.5,
      fontWeight: 600,
      color: '#1d1d1f',
      background: '#F5F5F7',
      border: '1px solid rgba(0,0,0,0.1)',
      borderBottom: '2px solid rgba(0,0,0,0.14)',
      borderRadius: 5,
      padding: '2px 7px',
      minWidth: 22,
      textAlign: 'center',
      display: 'inline-block',
    }}
  >
    {children}
  </kbd>
);

const ShortcutsModal = ({ isOpen, onClose }) => {
  const { t } = useLanguage();
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onClose();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 ap-modal-backdrop"
      style={{ zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}
      onClick={onClose}
    >
      <div
        style={{
          width: '100%',
          maxWidth: 380,
          background: '#fff',
          borderRadius: 16,
          border: '1px solid rgba(0,0,0,0.08)',
          boxShadow: '0 8px 30px rgba(0,0,0,0.2), 0 2px 8px rgba(0,0,0,0.1)',
          overflow: 'hidden',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '16px 18px', borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
          <h2 style={{ fontSize: 15, fontWeight: 600, color: '#1d1d1f', margin: 0, letterSpacing: '-0.01em' }}>
            {t('shortcuts.title', 'Atajos de teclado')}
          </h2>
          <button
            onClick={onClose}
            aria-label={t('shortcuts.close', 'Cerrar')}
            style={{ width: 26, height: 26, borderRadius: '50%', background: 'rgba(0,0,0,0.06)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6e6e73' }}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M18 6L6 18M6 6l12 12" strokeLinecap="round" />
            </svg>
          </button>
        </div>
        <div style={{ padding: '8px 18px 18px' }}>
          {SHORTCUTS.map((s, i) => (
            <div
              key={i}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 12,
                padding: '10px 0',
                borderBottom: i < SHORTCUTS.length - 1 ? '1px solid rgba(0,0,0,0.05)' : 'none',
              }}
            >
              <span style={{ fontSize: 13.5, color: '#1d1d1f' }}>{t(`shortcuts.${s.key}`, s.label)}</span>
              <span style={{ display: 'flex', gap: 4, flexShrink: 0 }}>
                {s.keys.map((k, j) => <Kbd key={j}>{k}</Kbd>)}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ShortcutsModal;
